// Copy this into the array below to add a new open question.
// Markdown file goes at public/markdown/blog/questions/<slug>.md (filename must match slug).
// {
//   title: 'Why does...?',
//   slug: 'why-does-something-happen',
//   opened: '2026-08-24',
//   excerpt: 'One-line summary shown in the list and used for search.',
//   tags: ['Tag One', 'Tag Two'],
// },

const data = [];

export default data;
